import React from 'react'

import { useTranslation } from 'react-i18next'
import { Card } from '../../../../component-library/components/card/card.component'
import { StyledHeading, StyledSubheading } from '../order-form.component.styles'
import {
  InsuranceLink,
  FlexContainer,
  StyledExternalLinkIcon,
} from './insurance-info.component.styles'
import { orderTrackingService } from '../../tracking.service'

const InsuranceInfo = () => {
  const [t] = useTranslation()
  const insuranceURL = t('delivery__gogox_rebranding_url_insurance')

  return (
    <Card>
      <StyledHeading>{t('orderDetails.insurance.insurance')}</StyledHeading>
      <StyledSubheading>
        {t('orderDetails.insurance.businessCoverage')}
      </StyledSubheading>
      <InsuranceLink
        href={insuranceURL}
        target="_blank"
        onClick={() =>
          orderTrackingService.trackTextLinkClicked({
            url: insuranceURL,
            urlName: 'Cargo Compensation',
          })
        }
      >
        <FlexContainer>
          {t('orderDetails.insurance.viewDetails')}
          <StyledExternalLinkIcon />
        </FlexContainer>
      </InsuranceLink>
    </Card>
  )
}

export { InsuranceInfo }
